import { Box, Skeleton } from '@mui/material'
import React from 'react'

export const Loader = () => {
    return (
        <Box width="100%" p="16px 24px" display="flex" flexDirection="column" gap="24px">
            <Skeleton sx={{bgcolor: '#F2F6F9', borderRadius: '6px'}} variant="rounded" width="80%" height={50}/>
            <Box width="100%" display="flex" alignItems="center" gap="12px">
                <Skeleton sx={{bgcolor: '#F2F6F9'}} variant="circular" width={50} height={45}/>
                <Box width="100%" display="flex" flexDirection="column" gap="6px">
                    <Skeleton sx={{bgcolor: '#F2F6F9', borderRadius: '6px'}} variant="rounded" width="80%" height={15}/>
                    <Skeleton sx={{bgcolor: '#F2F6F9', borderRadius: '6px'}} variant="rounded" width="40%" height={15}/>
                </Box>
            </Box>
            <Skeleton sx={{bgcolor: '#F2F6F9', borderRadius: '6px'}} variant="rounded" width="100%" height={180}/>
            <Box display="flex" flexDirection="column" gap="8px">
                <Skeleton sx={{bgcolor: '#F2F6F9', borderRadius: '6px'}} variant="rounded" width="60%" height={15}/>
                <Skeleton sx={{bgcolor: '#F2F6F9', borderRadius: '6px'}} variant="rounded" width="100%" height={15}/>
                <Skeleton sx={{bgcolor: '#F2F6F9', borderRadius: '6px'}} variant="rounded" width="80%" height={15}/>
                <Skeleton sx={{bgcolor: '#F2F6F9', borderRadius: '6px'}} variant="rounded" width="100%" height={15}/>
            </Box>
        </Box>
    )
}
